var map = {
	"./bookshelves/bookshelf-basic-1.png": 1593,
	"./bookshelves/bookshelf-basic-2.png": 1594,
	"./bookshelves/bookshelf-basic-3.png": 1595,
	"./bookshelves/bookshelf-basic-4.png": 1596,
	"./bookshelves/bookshelf-beach.png": 1597,
	"./bookshelves/bookshelf-chef.png": 1598,
	"./bookshelves/bookshelf-circus.png": 1599,
	"./bookshelves/bookshelf-gamer.png": 1600,
	"./bookshelves/bookshelf-jam.png": 1601,
	"./bookshelves/bookshelf-pirate.png": 1602,
	"./bookshelves/bookshelf-skate.png": 1603,
	"./bookshelves/bookshelf-sports.png": 1604,
	"./bookshelves/bookshelf-winter.png": 1605,
	"./bookshelves/bookshelf-wizard.png": 1606,
	"./floor_items/basketball.png": 1607,
	"./floor_items/chest.png": 1608,
	"./floor_items/coffee-table.png": 1609,
	"./floor_items/electric-guitar.png": 1610,
	"./floor_items/fireplace.png": 1611,
	"./floor_items/football.png": 1612,
	"./floor_items/game-controller.png": 1613,
	"./floor_items/green-skateboard.png": 1614,
	"./floor_items/magic-book.png": 1615,
	"./floor_items/magic-staff.png": 1616,
	"./floor_items/mask.png": 1617,
	"./floor_items/palm-tree.png": 1618,
	"./floor_items/popcorn.png": 1619,
	"./floor_items/red-skateboard.png": 1620,
	"./floor_items/sandcastle.png": 1621,
	"./floor_items/side-table.png": 1622,
	"./floor_items/violin.png": 1623,
	"./floor_items/wand.png": 1624,
	"./sofas/sofa-beach.png": 1625,
	"./sofas/sofa-chef.png": 1626,
	"./sofas/sofa-circus.png": 1627,
	"./sofas/sofa-gamer.png": 1628,
	"./sofas/sofa-jam.png": 1629,
	"./sofas/sofa-pirate.png": 1630,
	"./sofas/sofa-skate.png": 1631,
	"./sofas/sofa-sports.png": 1632,
	"./sofas/sofa-winter.png": 1633,
	"./sofas/sofa-wizard.png": 1634,
	"./wall_items/double-note-poster.png": 1635,
	"./wall_items/dragon-poster.png": 1636,
	"./wall_items/elephant-poster.png": 1637,
	"./wall_items/helm.png": 1638,
	"./wall_items/pirate-flag.png": 1639,
	"./wall_items/rocket-poster.png": 1640,
	"./wall_items/single-note-poster.png": 1641,
	"./wall_items/surfboard.png": 1642,
	"./wall_items/television.png": 1643,
	"./wall_items/window-night-beach.png": 1644,
	"./wall_items/window-night-lake.png": 1645,
	"./wall_items/window-night-mountains.png": 1646,
	"./wall_items/window-snowy-mountains.png": 1647,
	"./wall_items/window-sunny-beach.png": 1648,
	"./wall_items/window-sunny-lake.png": 1649,
	"./wall_items/window-sunny-mountains.png": 1650,
	"./wall_items/window-sunset-beach.png": 1651,
	"./wall_items/window-sunset-lake.png": 1652
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 690;



//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures .*\.png
// module id = 690
// module chunks = 0